export const isPWAMyViasat = (): boolean => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const version = window.NATIVE_APP_INFO?.version ?? '4.0.0';
  const majorVersionNumber = parseInt(version.split('.')[0], 10);

  return majorVersionNumber >= 5;
};
